/** OPHUB's 409 when a share is requested while the workspace has shared emails off. */
export const SHARED_EMAIL_DISABLED_ERROR_CODE = "CommunicationChannel.SharedEmail.Disabled";
